module.exports = __webpack_public_path__ + "static/media/allergy_soja.19931067.png";